// 在庫管理サブシステム（設計 2026-11-03 §3.1）。メニューは「在庫管理」1 つ（= 在庫一覧）。
// 伝票・棚卸・AI 下書きは在庫一覧のボタンから、品目マスタと取り込んだメールは設定から開く。外した項目のルートは残す。
const meta = (menu) => ({ requiresAuth: true, requiresBizhub: true, ...(menu ? { menu } : {}) });
export default [
  { path: "stock", name: "BizhubStock", component: () => import("@/views/Bizhub/StockListView.vue"),
    meta: meta({ group: "在庫管理", title: "在庫一覧", order: 10 }) },
  { path: "items/:id", name: "BizhubItemDetail", component: () => import("@/views/Bizhub/ItemDetailView.vue"), meta: meta() },
  // 旧の台帳（アシスタントや古いリンク）→ 在庫詳細
  { path: "items/:id/ledger", name: "BizhubItemLedger", redirect: (to) => ({ name: "BizhubItemDetail", params: { id: to.params.id } }) },
  { path: "movements", name: "BizhubMovements", component: () => import("@/views/Bizhub/MovementListView.vue"), meta: meta() },
  { path: "stocktake", name: "BizhubStocktake", component: () => import("@/views/Bizhub/StocktakeView.vue"), meta: meta() },
  { path: "drafts", name: "BizhubDrafts", component: () => import("@/views/Bizhub/DraftView.vue"), meta: meta() },
  // 旧の場所 → 設定（品目マスタは settings/items、受信箱は 設定 → メール連携 の「取り込んだメール」）
  { path: "items", redirect: { name: "BizhubItems" } },
  { path: "supplier-items", name: "BizhubSupplierItems", redirect: { name: "BizhubItems" } },
  { path: "mail", name: "BizhubMail", redirect: (to) => ({ name: "BizhubMailSettings", query: to.query }) },
];
